module.exports = require('./lib/KeyCode.js').default;



//////////////////
// WEBPACK FOOTER
// ./~/keycode-js/index.js
// module id = 53
// module chunks = 0